import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatSessionState } from '../../../types/chat-session.types';

const STATE_LABELS: Record<string, string> = {
    connecting: 'Подключение...',
    reconnecting: 'Переподключение...',
    error: 'Ошибка соединения',
    closed: 'Соединение закрыто',
};

@Component({
    selector: 'chat-state',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat-state.component.html',
    styleUrls: ['./chat-state.component.scss'],
})
export class ChatStateComponent {
    @Input() public state: ChatSessionState = 'connected';

    public get stateLabel(): string {
        return STATE_LABELS[this.state] ?? '';
    }
}
